<script>
import utils from '../../Utils'


export default {
  name: "CatMixin",
  components:{ 
  },
  data(){
    return {     
        transition:null,
        isMobile:false      
    }
  },
  created (){
    this.transition = this.getPageTransition;
    this.isMobile = utils.isMobile();
  },    
  methods : {

  },
}
</script>